import { styled } from 'styled-components';

export const Container = styled.div`
    .prefix {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        border-radius: 4px;
        font-size: 12px;
        background-color: var(--color-surface);
        color: var(--color-on-surface);
    }

    .ant-color-picker-trigger {
        border: unset;
        box-shadow: unset;
    }

    .ant-color-picker-color-block {
        border-radius: 8px;
    }

    .ant-color-picker-panel {
        background-color: var(--color-surface);
        border-color: var(--color-divider);

        .ant-color-picker-slider-container {
            .ant-color-picker-slider-rail {
                background-color: var(--color-surface);
            }

            .ant-color-picker-slider-handle {
                border-color: var(--color-surface);
            }
        }
    }
`;
